import React, { useEffect, useCallback } from 'react';
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import CardContainer from "./CardContainer";

import PropTypes from 'prop-types';
import {Flex} from "reflexbox";
import { informational} from "../courseContent/questionTypes";
import * as TYPES from "../courseContent/questionTypes";


const InformationPoint = (props) => {

  let navigate = useNavigate();

  const handleContinue = useCallback(() => {
    navigate(props.nextURL)
  }, [navigate, props.nextURL]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      handleContinue();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleContinue]);


  const subheader= props.type === informational ? "Information" : "Answer";

  const actionsComponent= (
    <Flex style={{justifyContent: 'flex-end'}}>
      <Button variant={'contained'} color={'primary'} onClick={handleContinue}>Continue</Button>
    </Flex>
  );
  return (
    <>
      <CardContainer
        location={props.location}
        additionalTitle={props.type === TYPES.answer && props.nOfNQuestions}
        subheader={subheader}
        locationDone={props.locationDone}
        actionsComponent={actionsComponent}
        //special images and content
        answerInfo={props.answerInfo || null}
        heading={props.heading || null}
        //images and content
        cardMediaImg={props.image1 || null}
        cardMediaImg1Caption={props.image1Caption || null}
        cardContent1={props.content1}
        cardMediaImg2={props.image2 || null}
        cardMediaImg2Caption={props.image2Caption || null}
        cardContent2={props.content2 || null}
        cardMediaImg3={props.image3 || null}
        cardMediaImg3Caption={props.image3Caption || null}
        cardContent3={props.content3 || null}
        //
        answeredIncorrect={props.answeredIncorrect || null}
      />
    </>
  )
};

CardContainer.propTypes = {
  location: PropTypes.object.isRequired,
  cardContent1: PropTypes.any.isRequired,
  image1: PropTypes.string,
  image1Caption: PropTypes.string,
  image2Caption: PropTypes.string,
  image3Caption: PropTypes.string,
  nextURL: PropTypes.string,
  type: PropTypes.string,
  nOfNQuestions: PropTypes.any,
};

export default InformationPoint;